export const  Prices = {
 FREE:"price_1RpKR6EbQT4GsskarGkFWiZ3",
 ENTREPRISE:"price_1RpKRDEbQT4Gsska0qVxVdiG",
 ADVANCED : "price_1RpKRBEbQT4Gsska8Q5rr2Xt",
 BASIC : "price_1RpKR9EbQT4Gsska4xU95Qun",

};
export const  PlanType = {
    FREE : 'free',
    ADVACED : "adv",
    BASIC : "bas",
    ENTREPRISE : "ent",
    ONETIMEDEAL : "one"
  }
export const TimePlan ={
  MONTHLY : "monthly",
  YEARLY : "yearly",
}
export const PlanName ={
  ent : "ENTREPRISE",
  adv : "ADVANCED",
  bas : "BASIC",
  free : "FREE",
  one : "ONETIMEDEAL"
}


export function getPlanName(planType) {
  return PlanName[planType] || "UNKNOWN";
}
Object.freeze(Prices);